/* v8 ignore start */
import { storage } from '@/util';

import { KEYS } from '../constant';
import type { ShortcutMap } from '../type';

const loadShortcut = <
  NS extends Dictionary<string>,
  CMD extends Dictionary<string>,
>(
  defaultShortcut?: ShortcutMap<NS, CMD>,
) => {
  const customShortcutMap = storage.local.get<ShortcutMap<NS, CMD>>(
    KEYS.STORAGE_CUSTOM_SHORTCUT,
  );

  return customShortcutMap ?? defaultShortcut;
};

export default loadShortcut;
/* v8 ignore end */
